export default function catalog() {
  const catalog = document.querySelector(".catalog");

  if (!catalog) return;

  // Функция по сокращению текста
  String.prototype.limit = function (limit, userParams) {
    var text = this,
      options = {
        ending: "...", // что дописать после обрыва
        trim: true, // обрезать пробелы в начале/конце?
        words: true, // уважать ли целостность слов?
      },
      prop,
      lastSpace;

    //  проверить limit, без него целого положительного никак
    if (limit !== parseInt(limit) || limit <= 0) return this;

    // применить userParams
    if (typeof userParams == "object") {
      for (prop in userParams) {
        if (userParams.hasOwnProperty.call(userParams, prop)) {
          options[prop] = userParams[prop];
        }
      }
    }

    // убрать пробелы в начале /конце
    if (options.trim) text = text.trim();

    if (text.length <= limit) return text; // по длине вписываемся и так

    text = text.slice(0, limit); // тупо отрезать по лимиту
    lastSpace = text.lastIndexOf(" ");
    if (options.words && lastSpace > 0) {
      // урезать ещё до границы целого слова
      text = text.substr(0, lastSpace);
    }

    return text + options.ending;
  };

  // Добавления многоточия в карточке программы
  function resizeTextPrograms() {
    try {
      const titles = catalog.querySelectorAll(".catalog__program-title"),
        descriptions = catalog.querySelectorAll(
          ".catalog__program-description"
        );

      titles.forEach((element) => {
        if (window.innerWidth > 500) {
            element.textContent = element.textContent.limit(52);
        } else {            
            element.textContent = element.textContent.limit(32);
        }
      });

      if (window.innerWidth > 767) {
        descriptions.forEach((element) => {
          element.textContent = element.textContent.limit(82, {
            words: false,
          });
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  // Функция для отображения элементов и кнопки
  function initShowMoreButton(container, visibleItems) {
    const itemsContainer = document.querySelector(container);
    if (!itemsContainer) return;
    const showMoreButton = itemsContainer.querySelector('[data-show-button]');
    const items = Array.from(
      itemsContainer.querySelectorAll('[data-collapse-item]')
    ).filter((item) => item.style.display !== 'none');

    // Обнуление перед переинициализацией
    items.forEach((item) => {
      item.style.display = null;
      item.style.opacity = 1;
    });

    if (showMoreButton) {
      showMoreButton.classList.remove('hidden');
      showMoreButton.textContent = 'Показать все программы';
    }

    if (items.length <= visibleItems) {
      showMoreButton?.classList.add('hidden');
      return;
    }

    const hiddenItems = items.slice(visibleItems);
    hiddenItems.forEach((item) => {
      item.style.display = 'none';
      item.style.opacity = 0;
    });

    const onShowMoreButtonClick = () => {
      hiddenItems.forEach((item) => {
        item.style.display = null;
        setTimeout(() => {
          item.style.opacity = 1;
        });
      });
      showMoreButton.textContent = 'скрыть программы';
      showMoreButton.removeEventListener('click', onShowMoreButtonClick);
      showMoreButton.addEventListener('click', onCollapseButtonClick);
    };

    const onCollapseButtonClick = () => {
      hiddenItems.forEach((item) => {
        setTimeout(() => {
          item.style.display = 'none';
        }, 250);
        item.style.opacity = 0;
      });
      showMoreButton.textContent = 'Показать все программы';
      showMoreButton.removeEventListener('click', onCollapseButtonClick);
      showMoreButton.addEventListener('click', onShowMoreButtonClick);
      scrollToTop();
    };

    showMoreButton?.addEventListener('click', onShowMoreButtonClick);

    document.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-filter]')) {
        showMoreButton.removeEventListener('click', onCollapseButtonClick);
      }
    });
  }

  /* Плавный скролл в начало блока списка программ */
  function scrollToTop() {
    let scropllBlock = document.querySelector(".catalog");
    if (scropllBlock) {
      scropllBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  /* Инфоблок об отсутствии программ */
  (() => {
    const infoBlock = catalog.querySelector(".catalog__programs-empty");
    const cards = catalog.querySelectorAll(".catalog__program");

    if (!cards.length) {
      infoBlock.classList.remove("is-hidden");
    }
  })();

  resizeTextPrograms();
  initShowMoreButton('.catalog__wrapper', 8)
}
